// removed by extract-text-webpack-plugin
module.exports = {"container":"_31xW4F2"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Icon/index.css
// module id = ./template/components/Icon/index.css
// module chunks = client.sitechrome